import { render, staticRenderFns } from "./Co20Page.vue?vue&type=template&id=5ed9d5b2"
import script from "./Co20Page.vue?vue&type=script&lang=js"
export * from "./Co20Page.vue?vue&type=script&lang=js"
import style0 from "./Co20Page.vue?vue&type=style&index=0&id=5ed9d5b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports